export function debug_log (...args: unknown[]): void {
  if (is_debug_logging_enabled()) console.debug(...args)
}

export function debug_warn (...args: unknown[]): void {
  if (is_debug_logging_enabled()) console.warn(...args)
}

function is_debug_logging_enabled (): boolean {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('meshinator-debug-logs') === '1'
  } catch (_) {
    return false
  }
}
